import {Component} from "react"
import CardCol from "../../../Styled/Card/CardCol.jsx"

class ShortcutsFilterBar  extends Component {

  constructor(props) {
    super(props)

    this.shortcuts = [
      {key: 'FOLLOW', fillOwnerFilter: true, label: 'Suivi à réaliser'},
      {key: 'TO_VALIDATE', fillOwnerFilter: true, label: 'À valider'},
      {key: 'MET_TO_RELAUNCH', fillOwnerFilter: true, label: 'Rencontrés à relancer'},
      {key: 'COMPLETE', fillOwnerFilter: true, label: 'Complets'},
      {key: 'UNIVERSE', fillOwnerFilter: false, label: 'Univers'},
      {key: 'OWNER', fillOwnerFilter: false, label: 'Propriétaires'},
    ]
  }

  render() {
    const {shortcuts} = this
    const {onShortcutClick, isMobile, activeShortcut} = this.props

    return <CardCol
      className={`${isMobile ? "freelance-list-filterbar-shortcuts-mobile": "freelance-list-filterbar-shortcuts"}`}
      flex="auto">
      Raccourcis :

      {
        shortcuts.map((shortcut, index) => {
          return (
            <button
              key={`shortcut-button-${index}`}
              type="button"
              className={`btn btn-sm ${(activeShortcut === shortcut.key) ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => onShortcutClick(shortcut.key, shortcut.fillOwnerFilter)}>
              {shortcut.label}
            </button>
          )
        })
      }
    </CardCol>
  }
}

export default ShortcutsFilterBar